export default __webpack_public_path__ + "static/media/hegn.f88bcdb7.svg";